export default class JobsService {

    constructor(resource, slug) {
        if(slug) {
            this._resource = resource('job/'+slug);
        } else {
            this._resource = resource('job/');
        }
    }

    jobs() {
        return this._resource
            .query()
            .then( res =>  {
                return res.json();
            }, err => {
                throw new Error('Não foi possível obter a lista de publicacoes.');
            });
    }
}



// WEBPACK FOOTER //
// ./src/domain/JobService.js